module.exports = __webpack_public_path__ + "static/media/partiallyConfirmed-order.f0329bf7.svg";